"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerError = exports.NetworkUnavailable = exports.BaseError = exports.Pending = exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var CloudOff_1 = __importDefault(require("@material-ui/icons/CloudOff"));
var Error_1 = __importDefault(require("@material-ui/icons/Error"));
exports.useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        root: function (props) { return ({
            width: "100%",
            height: "100%",
            minHeight: props.size === "lg" ? "300px" : props.size === "md" ? "200px" : "100px",
            position: "relative",
        }); },
        centerArea: {
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
        },
        iconLg: {
            height: 200,
            width: 200,
        },
        iconMd: {
            height: 100,
            width: 100,
        },
        iconSm: {
            height: 50,
            width: 50,
        },
    });
});
exports.Pending = function (_a) {
    var size = _a.size;
    var classes = exports.useStyles({ size: size });
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement("div", { className: classes.centerArea },
            react_1.default.createElement(core_1.CircularProgress, { className: size === "sm"
                    ? classes.iconSm
                    : size === "md"
                        ? classes.iconMd
                        : classes.iconLg }))));
};
exports.BaseError = function (props) {
    var retry = props.retry, Icon = props.Icon, headingText = props.headingText, subText = props.subText, size = props.size;
    var classes = exports.useStyles({ size: size });
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement("div", { className: classes.centerArea },
            react_1.default.createElement(Icon, { className: size === "lg"
                    ? classes.iconLg
                    : size == "md"
                        ? classes.iconMd
                        : classes.iconSm }),
            headingText && (react_1.default.createElement(core_1.Typography, { variant: size === "sm" ? "h3" : size === "md" ? "h4" : "h5", component: "div" }, headingText)),
            subText && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("br", null),
                react_1.default.createElement(core_1.Typography, null, subText))),
            react_1.default.createElement("br", null),
            retry ? (react_1.default.createElement("button", { type: "reset", onClick: retry }, "Retry")) : null)));
};
exports.NetworkUnavailable = function (props) {
    var retry = props.retry, size = props.size;
    return (react_1.default.createElement(exports.BaseError, { size: size, Icon: CloudOff_1.default, headingText: "Offline", retry: retry }));
};
exports.ServerError = function (props) {
    var code = props.code, message = props.message, size = props.size;
    return (react_1.default.createElement(exports.BaseError, { size: size, Icon: Error_1.default, headingText: code ? "" + code : "Unknown Error", subText: message === "ajax error 404" ? "Not Found" : message }));
};
//# sourceMappingURL=index.js.map